import { useAnalytics } from '@townsquare/analytics';
import { getModifiedShortcut, useKeyboardShortcut } from '@townsquare/keyboard-shortcuts';
import {
	GO_DIRECTORY_SHORTCUT,
	GO_GOALS_PAGE_SHORTCUT,
} from '@townsquare/keyboard-shortcuts/constants';
import { useKeyboardShortcutStore } from '@townsquare/keyboard-shortcuts/store';
import { useRouterActions } from '@townsquare/router/primitives/actions';
import { goalDirectoryRoute } from '@townsquare/routes/goal-directory-view';

export const useKeyboardShortcuts = (): void => {
	const analytics = useAnalytics();
	const { pushTo } = useRouterActions();
	const [{ type }] = useKeyboardShortcutStore();

	const handleGoToKeypress = (_e: KeyboardEvent, keypress: string | undefined) => {
		switch (keypress) {
			case getModifiedShortcut(type, GO_DIRECTORY_SHORTCUT):
				void analytics.ui(
					'keyboardShortcut',
					'pressed',
					{ shortcutType: type },
					'goHomePageShortcut',
				);
				void pushTo(goalDirectoryRoute);
				break;
			case getModifiedShortcut(type, GO_GOALS_PAGE_SHORTCUT):
				void analytics.ui(
					'keyboardShortcut',
					'pressed',
					{ shortcutType: type },
					'goGoalsPageShortcut',
				);
				void pushTo(goalDirectoryRoute);
				break;
		}
	};

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_DIRECTORY_SHORTCUT, handleGoToKeypress);
	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_GOALS_PAGE_SHORTCUT, handleGoToKeypress);
};
